import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMetaDataGridActionState, DwModalButtonStandardConfigs,
    DwModalConfig, DwModalService, DwSecurityUserService, ensureArray } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChallengeDefinitionEntity } from '../../meta-data/app-meta-data.service';
import { AppPermissions } from '../../meta-data/app-permissions.enum';
import { ReprocessChallengeModalComponent } from './reprocess-challenge-modal.component';
import { ProcessingRow } from './challenge-processing.service';

@DwAction({keyName: 'reprocess-challenge', display: 'Reprocess challenge', actionType: DwActionType.menuAction,
    isGlobal: true, allowOnce: true, configData: {requireValidation: false, redirectAfter: false, actionMessage: ''}})
@Injectable()
export class ReprocessChallengeActionService implements DwActionHandler {
    constructor(private _modal: DwModalService, private _security: DwSecurityUserService) {}
    handleAction(state: DwMetaDataGridActionState): Observable<DwActionResult> {
        const result = new DwActionResult(); result.success = false;
        if (!this._security.hasPermission(AppPermissions.entAdminCanAccess)) { result.message = 'Administrator access is required.'; return of(result); }
        // Context-menu state includes the clicked row when there are no selected checkboxes.
        let rows: ChallengeDefinitionEntity[] = ensureArray(state.data);
        if (!rows.length) { rows = ensureArray(state.metaDataGridApi.getSelectedRows()); }
        const ids = Array.from(new Set(rows.map(row => Number(row.ChallengeDefinitionId)).filter(id => Number.isSafeInteger(id) && id > 0)));
        if (!ids.length) { result.message = 'Select one or more challenges.'; return of(result); }
        const modal = new DwModalConfig<{challengeIds: number[]}>();
        modal.title = 'Reprocess challenges'; modal.component = ReprocessChallengeModalComponent; modal.data = {challengeIds: ids};
        modal.buttons = DwModalButtonStandardConfigs.instance.SaveAndCancel.map(button => ({...button}));
        modal.buttons[0].buttonText = 'Process'; modal.buttons[0].useParentDisplay = false;
        modal.customModalWidth = '1000px'; modal.customModalHeight = 'auto'; modal.preventClose = true;
        return this._modal.showModal(modal).pipe(map(value => {
            const rows: ProcessingRow[] = value.data || [];
            const failed = rows.filter(row => row.state === 'failed').length;
            result.cancelled = value.cancelled; result.success = !value.cancelled && rows.length > 0 && failed === 0;
            if (rows.length) {
                state.metaDataGridApi.refreshDataSource(true);
                result.message = `${rows.length - failed} challenges processed; ${failed} need review.`;
            }
            return result;
        }));
    }
}
